var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFridgeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 474 474",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 474 474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m336,280.5v-273c0-4.142-3.358-7.5-7.5-7.5h-183c-4.142,0-7.5,3.358-7.5,7.5v273c0,3.802 2.832,6.936 6.5,7.426v5.348c-3.668,0.49-6.5,3.624-6.5,7.426v159.8c0,4.142 3.358,7.5 7.5,7.5h6.651c0.695,3.423 3.721,6 7.349,6s6.654-2.577 7.349-6h140.301c0.695,3.423 3.721,6 7.349,6s6.654-2.577 7.349-6h6.651c4.142,0 7.5-3.358 7.5-7.5v-159.801c0-3.802-2.832-6.936-6.5-7.426v-5.348c3.669-0.489 6.501-3.623 6.501-7.425zm-15,172.5h-168v-82.5h0.73c10.901,0 19.77-8.869 19.77-19.77v-42.531h147.5v144.801zm-157.5-144.801v42.531c0,5.387-4.383,9.77-9.77,9.77h-0.73v-52.301h10.5zm-4-15v-5.199h155v5.199h-155zm4-20.199h-10.5v-56.5h0.73c5.387,0 9.77,4.383 9.77,9.77v46.73zm157.5-258v258h-147.5v-46.73c0-10.901-8.869-19.77-19.77-19.77h-0.73v-191.5h168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237,68.5c9.098,0 16.5-7.402 16.5-16.5s-7.402-16.5-16.5-16.5-16.5,7.402-16.5,16.5 7.402,16.5 16.5,16.5zm0-23c3.584,0 6.5,2.916 6.5,6.5s-2.916,6.5-6.5,6.5-6.5-2.916-6.5-6.5 2.916-6.5 6.5-6.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridgeSvgrepoCom);
export default __webpack_public_path__ + "static/media/fridge-svgrepo-com.4734c9be5841f6e476bdf465687846c5.svg";
export { ForwardRef as ReactComponent };